import React from "react";
import classes from "./Card.module.scss";

export default function Card({
    color,
    children,
    isDisabled = false,
    onClick,
}) {
    return (
        <div
            className={`${classes.card} ${classes[color]} ${isDisabled ? classes.disabled : ""}`}
            aria-disabled={isDisabled}
            data-testid="card"
            onClick={onClick}
        >
            <div className={classes.containerChildren}>{children}</div>
        </div>
    );
}
